import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import SuccessIcon from '@swf/core/assets/icons/success.svg';

import { CancelledCashoutStatus } from '../../../../../../types/status';

import {
  TXTCLI_For_more_informationX_please_v_ELL_1,
  TXTWCL_Go_to_your_transaction_history_ELL,
  TXTWCL_One_or_more_of_your_withdrawal_ELL,
  TXTWCL_Request_successful,
  TXTWCL_SorryX_something_went_wrong_3,
  TXTWCL_Withdrawal_unavailable,
  TXTWCL_Your_withdrawal_is_now_under_r_ELL
} from './ResultContent.messages.json';
import { icon, subTitle, wrapper } from './ResultContent.scss';

interface Props {
  status: CancelledCashoutStatus;
  singleTransaction: boolean;
}

const ResultContent: React.FC<Props> = ({ status, singleTransaction }) => {
  switch (status) {
    case CancelledCashoutStatus.COMPLETED:
      return (
        <div className={wrapper}>
          <SuccessIcon className={icon} />
          <Translation tagName="h2" {...TXTWCL_Request_successful} />
          <div className={subTitle}>
            <Translation {...TXTWCL_Go_to_your_transaction_history_ELL} />
          </div>
        </div>
      );
    case CancelledCashoutStatus.NOT_CANCELLABLE:
      return (
        <>
          <Translation tagName="h2" {...TXTWCL_Withdrawal_unavailable} />
          {singleTransaction ? (
            <Translation {...TXTWCL_Your_withdrawal_is_now_under_r_ELL} />
          ) : (
            <Translation {...TXTWCL_One_or_more_of_your_withdrawal_ELL} />
          )}
        </>
      );
    default:
      return (
        <>
          <Translation tagName="h2" {...TXTWCL_SorryX_something_went_wrong_3} />
          <Translation
            tagName="div"
            {...TXTCLI_For_more_informationX_please_v_ELL_1}
            values={{
              a: (msg: React.ReactNode) => (
                <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
              )
            }}
          />
        </>
      );
  }
};

export default ResultContent;
